<div class="flex flex-column w-full h-screen min-h-screen">
  <!-- Navigation -->
  <medsurf-navbar></medsurf-navbar>
  <!-- Toolbar -->
  <medsurf-design-content-toolbar class="mb-2">
    <div class="p-toolbar-group-start">
      <button medsurf-design-input-button id="stain_add"
        [label]="'global.stain_add' | translate"
        [iconClass]="FlatModels.ButtonDesignModels.ButtonDefaultIcons.ADD"
      (click)="addNewStain()"></button>
    </div>
  </medsurf-design-content-toolbar>
  <!-- Content -->
  @if (constantAuthorFacade.stains$ | async; as stains) {
    <p-table
      [value]="stains"
      class="flex flex-1 overflow-hidden align-self-center w-11 lg:w-5 mb-2"
      styleClass="w-full"
      [rowTrackBy]="rowTrackBy"
      [scrollable]="true"
      scrollHeight="100%"
      selectionMode="single"
      (onRowSelect)="onRowSelect($event)"
      sortField="name">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="name">
            <span translate="global.name"></span> <p-sortIcon field="name"></p-sortIcon>
          </th>
          <th pSortableColumn="shortcut">
            <span translate="global.shortcut"></span> <p-sortIcon field="shortcut"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-stain>
        <tr [pSelectableRow]="stain.id">
          <td>
            {{stain.name}}
          </td>
          <td>
            {{stain.shortcut}}
          </td>
        </tr>
      </ng-template>
    </p-table>
  }
</div>
